import {
  AttachmentFragment,
  useGetWorkflowInstanceDisplayNamesQuery,
} from '@spotify/confidence-graphql';

import { parseWorkflowInstanceName } from '../resourceUri';

export const useResolvedWorkflowName = (
  artifact: AttachmentFragment,
): string | undefined => {
  const name = parseWorkflowInstanceName(artifact.uri);
  const { data } = useGetWorkflowInstanceDisplayNamesQuery({
    variables: { filter: name ? `name:"${name}"` : '' },
    skip: !name,
  });

  const response = data?.workflowInstances;
  if (!response || !('workflowInstances' in response)) {
    return undefined;
  }
  return response.workflowInstances.find(instance => instance.name === name)
    ?.displayName;
};
